import type { FaireProductEntity } from "../../entity_types/product";

export const p_bakb4o1z: FaireProductEntity = {
  token: "p_bakb4o1z",
  type: "product",
  name: "Baby Bib - Believe in Unicorns",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/7d0a47aed28b59aba05a288c091fd30d0a4b4210becd9ff745fd1cb54293b0db/1537889914.jpg",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/b34d7dd6d304eed84b0d7621a1446f859af99ae058aa2091be7ecbd1c612c907/1537890020.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/145a19401d87d760b90de96e29de47a08879fb0df3cee8fcc1803970293c5dfb/1537890033.png",
  ],
  priceDollars: 8,
  description:
    "The Believe in Unicorn's baby bib is perfect for smash cake photoshoots that are unicorn-themed. It's also a great first birthday bib or fun for everyday!\n\n𝐈𝐭𝐞𝐦 𝐝𝐞𝐬𝐜𝐫𝐢𝐩𝐭𝐢𝐨𝐧:\n• White bib with velcro closure\n• Gold glitter writing\n• 5.5 oz., 100% combed ringspun cotton jersey\n• Sewn with 100% cotton thread\n• Reinforced hook and loop closure",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:26.204Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
